import { AppWorks } from "appworks/appworks";
import { Setup } from "appworks/boot/setup";
import { Services } from "appworks/services/services";

export class SlotWorks {

    public static go(
        setups: Setup | Setup[],
        assetworksData: any
    ) {
        const setupsArr = (Array.isArray(setups)) ? setups : [setups];
        setupsArr.forEach((x) => x.setupServices());

        Services.init();

        Services.settings.load();

        Services.bet.load();

        AppWorks.go(setups, assetworksData);
    }

    private constructor() { }
}
